import { Center, ErrorText, FileViewer, LoadingIndicator } from "@/components";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

import { useGetJobFile } from "@/hooks/queries/useGetJobFile";

const JobAttachmentViewer = ({
  jobFileId,
}: {
  jobFileId: number;
}) => {
  /* Database CRUD Operations */
  // Read
  const {
    data: jobFile,
    isPending: isJobFilePending,
    isError: isJobFileError,
  } = useGetJobFile({
    enabled: true,
    jobFileId,
  });

  /* Render */
  if (isJobFilePending) {
    return <LoadingIndicator className="absolute inset-0" variant="medium" />;
  }
  if (isJobFileError) {
    return (
      <Center className="absolute inset-0">
        <ErrorText errorMessage="An error occurred while loading file. Please try again." />
      </Center>
    );
  }

  return (
    <FileViewer mimeType={jobFile.mimeType} url={jobFile.signedUrl} />
  );
};

export const JobAttachmentViewerDialog = ({
  jobFileId,
  mimeType,
  onOpenChange,
  open,
}: {
  jobFileId?: number;
  mimeType?: string;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) => {
  const isImage = mimeType?.startsWith("image/");

  const render = () => (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        className={cn(
          "max-h-[92vh] max-w-4xl overflow-y-scroll",
          isImage && "w-fit",
        )}
      >
        {/* This ensures spacing between top of dialog and content. */}
        <DialogHeader />
        {/* The dialog should only be open when `jobFileId` is present. */}
        {jobFileId && (
          <JobAttachmentViewer jobFileId={jobFileId} />
        )}
      </DialogContent>
    </Dialog>
  );

  return render();
};
